import React, { useEffect, useState, useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { AuthContext } from "react-oauth2-code-pkce";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

export default function ProfileGate({ children }) {
  const location = useLocation();
  const auth = useContext(AuthContext);

  // ✔ These exist in your AuthContext
  const token = auth?.token;                     // access token (string)
  const identityId = auth?.tokenData?.sub;       // user ID
  const isAuthLoading = auth?.loginInProgress;   // loading flag

  const [loading, setLoading] = useState(true);
  const [profileUpdated, setProfileUpdated] = useState(null);

  /** ⭐ HOOKS MUST COME FIRST — ALWAYS RUN, NO CONDITIONS **/
  useEffect(() => {
    // Wait until AuthContext finishes loading
    if (isAuthLoading) {
      return;
    }

    // Wait until token + identityId are ready
    if (!token || !identityId) {
      return;
    }

    const fetchUpdateStatus = async () => {
      try {
        console.log("🔍 Checking profile status for:", identityId);

        const res = await axios.get(
          `${API_BASE_URL}/user/${identityId}/profile/updated/status`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const flag = res.data?.data?.profileUpdatedAfterRegistration ?? false;
        setProfileUpdated(flag);

        if (!flag) {
          toast.error("Please update your profile before accessing FamilyDuniya.");
        }
      } catch (err) {
        console.error("❌ Failed to fetch profile status:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUpdateStatus();
  }, [token, identityId, isAuthLoading]);

  /** ⭐ NOW we can do returns — AFTER hooks **/

  // Always allow access to profile page
  if (location.pathname.startsWith("/profile")) {
    return children;
  }

  // Show loading until everything is ready
  if (isAuthLoading || !token || !identityId || loading) {
    return <p>Loading…</p>;
  }

  // If the profile isn't updated → block access
  if (profileUpdated === false) {
    return (
      <Navigate
        to="/profile?forceUpdate=true"
        replace
        state={{ msg: "Please update your profile first" }}
      />
    );
  }

  // Otherwise allow access
  return children;
}
